import { authHeader, authHeaderForm } from '../helpers/auth-header';
import { client } from './';
import { documentListConstants } from '../containers/Documents/constants/document-list.constants';
import { documentsConstants } from '../containers/Documents/constants/documents.constants';
import { documentsActions } from '../containers/Documents/store/actions/documents.actions';
import constants from '../constants/org-in-params.constants';
import { requestsConstants } from '../containers/Requests/requests.constants';
import moment from 'moment'

const url = '/docs';

const actions = {
	openModal,
	closeModal,
	patchInParams,
};

function patchInParams(v) {
	let rurl = url + '/updateOrgInDoc/' + v.Id;
	return (dispatch, getState) => {
		client.put(rurl, v, { headers: authHeader() })
			.then((response) => {
				const rl = getState().documentsStore.documents.slice()
				const ri = rl.findIndex(el => '' + el.id === v.Id)				
				dispatch(documentsActions.fetchDocuments());
//				dispatch({
	//				type: re.SET_REQUEST_MASTER,
		//			payload: new Promise(resolve => { resolve({ data: rl }) }),
			//	})
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}	
}

function openModal(v) {
	return dispatch => {
		dispatch({
			type: constants.OPEN_ORG_PARAMS_MODAL,
			payload: v,
		})
	}
}

function closeModal(v) {
	return dispatch => {
		dispatch({
			type: constants.CLOSE_ORG_PARAMS_MODAL,
		})
	}
}

export default actions 
